// extracted by css-extract-rspack-plugin
var _1 = "option-rsJzA8";
var _2 = "optionMeta-aMqo3_";
var _3 = "optionTitleRow-EtnIY0";
var _4 = "promptTag-HiniYX";
export { _1 as "option", _2 as "optionMeta", _3 as "optionTitleRow", _4 as "promptTag" }
